import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { LawCitation, MarkdownWrap } from './detail/styles'
import Markdown from '../../common/components/markdown'
import { StyledExternalLink } from '../../theme/Global'
import { formatLink } from '../../common/helpers'

export const ContentBlock = function ({ contentBlock }) {
  return (
    <React.Fragment key={uuidv4()}>
      <MarkdownWrap>
        <Markdown>{contentBlock.content}</Markdown>
      </MarkdownWrap>
      {renderCitation(contentBlock.law)}
      {renderCitation(contentBlock.regulation)}
      {renderLink(contentBlock.primaryLink)}
      {renderLink(contentBlock.secondaryLink)}
    </React.Fragment>
  )
}

const renderLink = function (link) {
  if (link) {
    return (
      <div key={link} style={{ paddingBottom: '1rem' }}>
        <StyledExternalLink
          href={link}
        >
          {formatLink(link)}
        </StyledExternalLink>
      </div>
    )
  }
  return null
}

const renderCitation = function (regulation) {
  return (regulation) ? <LawCitation>{regulation}</LawCitation> : null
}
